import React from 'react';
import NavLink from "react-router-dom/es/NavLink";
import PropTypes from "prop-types";
import linkRewriter from "../../shared/linkRewriter";

/**
 * ContentLinkRenderer component is used to return a link
 * based on Contet Type returned from WCM.
 *
 * There are three main scenarios:
 *  - 1. "externalLink" or "file" will generate regular HTML anchor tag.
 *  - 2. "site". This is a Route to other page within the application.
 *       Will generate NavLink and path to other page.
 *  - 3. "text/html" or "internal". Will generate a link to an individual
 *       Content page, such as "NewsItem", "Press Release Item" or "Awards Item".
 *       The link will be generated in the following format:
 *
 *       props.pathForItem + "?id=" + props.id
 *
 *       Where
 *       * pathForItem - /about/news/news-item
 *       * props.id - id of the individual news
 *
 */

const contentLinkRenderer = (props) => {

  switch (props.contentType) {
    case "file": // path to a file
    case "externalLink": // path to an external Web Page
      return (
        <a
          className={props.className ? props.className : ''}
          style={props.style ? props.style : null}
          href={props.value}
          target={props.target ? props.target : ''}
        >{props.linkContent ? props.linkContent : 'Learn'}</a>);
    case "site": // internal route within the application
      return (
        <NavLink
          className={props.className ? props.className : ''}
          style={props.style ? props.style : null}
          to={linkRewriter(props.value)}
        >{props.linkContent ? props.linkContent : 'Learn'}</NavLink>
      );
    case "text/html": // dynamic path to individual web pages
    case "internal":
      return (
        <NavLink
          className={props.className ? props.className : ''}
          style={props.style ? props.style : null}
          to={linkRewriter(props.pathForItem) + "?id=" + props.id}
        >{props.linkContent ? props.linkContent : 'Learn'}</NavLink>
      );
    case null:
      return (
        <a
          className={props.className ? props.className : ''}
          style={props.style ? props.style : null}
          href={props.value}
          target={props.target ? props.target : ''}
        >{props.linkContent ? props.linkContent : 'Learn'}</a>
      );
    default:
      return null;
  }
};

export default contentLinkRenderer;


contentLinkRenderer.propTypes = {
  contentType: PropTypes.oneOf([
    "file",
    "text/html",
    "internal",
    "externalLink",
    "site"
  ]),
  value: PropTypes.string, // can be a link or HTML string for parser
  linkContent: PropTypes.any, // linkContent for the link, can be string or HTML/JSX Content
  className: PropTypes.string, // custom classses for links,
  style: PropTypes.any, // ability to insert inlines styles
  target: PropTypes.string, // new tab/window or not
  pathForItem: PropTypes.string, // path for the item page
  id: PropTypes.number, // id,
  onEmptyContent: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/components/Carousel/CarouselLinkRenderer.js